import { render } from "./News13.vue?vue&type=template&id=106e3a64"
import script from "./News13.vue?vue&type=script&lang=js"
export * from "./News13.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__